var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 156,
    viewBox: "0 0 246 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.e{fill:#4972f4;}.d{fill:#001536;}.e{opacity:0.2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 246,
    height: 156,
    transform: "translate(793 753)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-793 -753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6741.985 1039.924)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-5300.284-73.408l-48.143,27.8V-101.2l24.071,13.9Z",
    transform: "translate(-477.058 -135.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-5586.957-101.2v55.592l-24.074-13.9-24.072-13.9,24.072-13.9Z",
    transform: "translate(-238.528 -135.516)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5921.776 -264.516)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-5825.485,92.1l-24.074,13.9-24.072,13.9L-5897.7,106l-24.074-13.9,24.074-13.9,24.072-13.9,24.072,13.9Z",
    transform: "translate(5921.776 -8.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-5252.138-238.915l-24.072,13.9-24.074,13.9-24.072-13.9-24.071-13.9,24.071-13.9,24.072-13.9,24.074,13.9Z",
    transform: "translate(5444.718 266.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-5825.485-238.915l-24.074,13.9-24.072,13.9-24.072-13.9-24.074-13.9,24.074-13.9,24.072-13.9,24.072,13.9Z",
    transform: "translate(5921.776 266.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-5252.138,92.1l-24.072,13.9-24.074,13.9-24.072-13.9-24.071-13.9,48.143-27.8,24.074,13.9Z",
    transform: "translate(5444.718 -8.711)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.52908da3fd602b0819da992a7c8eb506.svg";
export { ForwardRef as ReactComponent };